import './HeroSection.css';
import videoBackground from '../assets/final.MOV';

const HeroSection = ({ children }) => {
  return (
    <div className="hero-section">
      <video className="hero-section__video" autoPlay loop muted playsInline>
        <source src={videoBackground} type="video/mp4" />
      </video>
      <div className="hero-section__content">
        {children}
      </div>
    </div>
  );
};

export default HeroSection;
